var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SearchParamType } from "@/types/SearchParamType";
import { Switch, useRecipe } from "@chakra-ui/react";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { SearchFormContext } from "@/components/cortex/components/SearchForm/SearchFormContext";
import { getUpdatedSearchParams } from "@/components/utils";
export function RemoteOnlyToggle() {
    var recipe = useRecipe({ key: "RemoteOnlyToggle" });
    var styles = recipe();
    var searchFormContext = useContext(SearchFormContext);
    var _a = useSearchParams(), searchParams = _a[0], setSearchParams = _a[1];
    var isRemoteOnlyValue = searchFormContext.isRemoteOnlyValue, setIsRemoteOnlyValue = searchFormContext.setIsRemoteOnlyValue, queryValue = searchFormContext.queryValue, locationValue = searchFormContext.locationValue, countryValue = searchFormContext.countryValue, companyValue = searchFormContext.companyValue, occupationValue = searchFormContext.occupationValue;
    function handleChange() {
        var newVal = !isRemoteOnlyValue;
        setIsRemoteOnlyValue(newVal);
        var updatedParams = getUpdatedSearchParams(searchParams, queryValue, locationValue, newVal, undefined, countryValue, companyValue, occupationValue);
        setSearchParams(updatedParams);
    }
    return (_jsxs(Switch.Root, __assign({ id: "remoteOnly", name: SearchParamType.IS_REMOTE_ONLY, checked: isRemoteOnlyValue, "aria-label": "Show remote jobs only", onChange: handleChange, css: styles }, { children: [_jsx(Switch.HiddenInput, {}), _jsx(Switch.Control, { children: _jsx(Switch.Thumb, { children: _jsx(Switch.ThumbIndicator, __assign({ fallback: _jsx(FontAwesomeIcon, { icon: faXmark }) }, { children: _jsx(FontAwesomeIcon, { icon: faCheck }) })) }) }), _jsx(Switch.Label, { children: "Show remote jobs only" })] })));
}
